import React from "react";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import Layout from "../modules/layout/Layout";
import styled from "styled-components";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DicomViewer from "../modules/dicom/DicomViewer";
import useAuthCheck from "../modules/userChkToken/userChkToken";

const MainInner = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
  height: calc(100vh - 63px);
  display: flex;
`;

const Viewer = () => {
  const { user_seq, patient_seq } = useParams();
  const location = useLocation();
  const userName = useSelector((state) => state.UserDetailsReducer.userName);

  //중복 로그인 방지 처리
  useAuthCheck(userName);

  return (
    <Layout user_seq={user_seq} patient_seq={patient_seq}>
      <MainInner>
        <DndProvider backend={HTML5Backend}>
          <DicomViewer
            key={location.key} // location.key를 key로 사용하여 안전한 초기화
            user_seq={user_seq}
            patient_seq={patient_seq}
          />
        </DndProvider>
      </MainInner>
    </Layout>
  );
};

export default Viewer;
